import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    fechaVencimiento: moment(new Date()).format('YYYY-MM-DD'),
    clienteId: 0,
    cliente: {},
    clienteNombre: null,
    clientePlazoPago: 0,
    condicionFiscalId: 0,
    condicionFiscalNombre: null,
    formaPagoId: 0,
    formaPago: null,
    formaPagoNombre: null,
    comprobanteTipoId: 0,
    comprobanteTipo: null,
    comprobanteTipoNombre: null,
    formulario: '',
    numeroPuntoVenta: 0,
    numero: 0,
    sistemaCirculacionAbierta: false,
    periodoAsociadoDesde: '1900-01-01',
    periodoAsociadoHasta: '1900-01-01',
    total: 0,
    monedaId: 0,
    moneda: null,
    monedaNombre: null,
    cotizacion: 0,
    montoGravado: 0,
    montoExento: 0,
    montoNoGravado: 0,
    montoIvaInscripto: 0,
    monedaPagoId: 0,
    monedaPago: null,
    monedaPagoNombre: null,
    montoGravadoLocal: 0,
    montoExentoLocal: 0,
    montoNoGravadoLocal: 0,
    montoIvaInscriptoLocal: 0,
    observaciones: '',
    renglones: [],
    renglonesDescripcion: [],
    rowVersion: null,

    certificadosServicio: false,
    facturaExportacion: false,
    /* Certificados con saldo del cliente */
    certificadosCliente: [],

    certificadosSeleccionados: true,
    certificadosSeleccionadosIndeterminado: false,

    pjeAlicuotaIva: 21,
    pjeCreditoDebito: 0,
    cotizacionDolar: 0,

    /* Opción del cliente */
    clienteSistemaCirculacionAbierta: false,

    cotizacionReadOnly: true,
    formularioReadOnly: false,

    opcionesFCEMyPime: false,
    montoNoGravadoVisible: true,
    formularioVisible: true,
    puntoVentaVisible: true,

    /* Pais (Empresa) */
    paisId: 0,

    ventaId: 0,
    venta: {
        montoGravado: 0,
        montoExento: 0,
        montoNoGravado: 0,
        montoIvaInscripto: 0,
    },
    ventaReferencias: [],

    creditoFinanciacion: false,
    creditoFinanciacionPresupuestos: [],
    creditoFeePresupuestos: [],
    pjeFinanciacion: 0,
    montoBaseCreditoFinanciacion: 0,
    /* Seleccion de comprobantes para la NCR x financiación */
    creditoFinanciacionCliente: {},
    creditoFinanciacionComprobantes: [],

    presupuestoInternoId: 0,
    presupuestoInternoNumero: null,
    presupuestoInternoCliente: null,
    presupuestoInternoAccion: null,
    ordenTrabajoId: 0,
    ordenTrabajo: null,

    monedas: [
        { id: 101, nombre: 'PESOS' },
        { id: 102, nombre: 'DOLARES' },
    ],
    monedasList:  ['PESOS', 'DOLARES'],

    comprobantesTipos: [],
    comprobantesTiposList: [],

    ventaDatos: [],
    ventaRenglonesDatos: [],
    ventaRenglonesDescripcionDatos: [],
    ventaAsociadasDatos: [],
    ventaReferenciasDatos: [],
    ventaDatosMoneda: '',
    ventaNegociacionDatos: [],

    ventaDatosRpt: [],
    ventaRenglonesDatosRpt: [],
    ventaRenglonesDescripcionDatosRpt: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_VENTA' (state, params) {
        state.id = 0;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaVencimiento = moment(new Date()).format('YYYY-MM-DD'),
        state.clienteId= 0;
        state.cliente= null;
        state.clienteNombre= null;
        state.clientePlazoPago = 0;
        state.condicionFiscalId= 0;
        state.condicionFiscalNombre= null;
        state.formaPagoId= 0;
        state.formaPago= null;
        state.formaPagoNombre= null;
        state.comprobanteTipoId= 0;
        state.comprobanteTipo= null;
        state.comprobanteTipoNombre= null;
        state.formulario = '';
        state.numeroPuntoVenta = 0;
        state.numero = 0;
        state.sistemaCirculacionAbierta = false;
        state.periodoAsociadoDesde = '1900-01-01',
        state.periodoAsociadoHasta = '1900-01-01',
        state.monedaId = 101;
        state.moneda = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';
        state.cotizacion = 1;
        state.total = 0;
        state.montoGravado= 0;
        state.montoExento= 0;
        state.montoNoGravado= 0;
        state.montoIvaInscripto= 0;
        state.monedaPagoId = 101;
        state.monedaPago = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaPagoNombre = 'PESOS';
        state.montoGravadoLocal= 0;
        state.montoExentoLocal= 0;
        state.montoNoGravadoLocal= 0;
        state.montoIvaInscriptoLocal= 0;
        state.observaciones = '';
        state.renglones = [];
        state.renglonesDescripcion = [];
        state.rowVersion = null;

        state.certificadosServicio = params.certificadosServicio;
        state.facturaExportacion = params.facturaExportacion;

        state.certificadosSeleccionados = false;
        state.certificadosSeleccionadosIndeterminado = false;
        state.certificadosCliente = [];

        state.ventaId = 0;
        state.venta = null;
        state.ventaReferencias = [];

        state.creditoFinanciacion = false;
        state.creditoFinanciacionPresupuestos = [];
        state.creditoFeePresupuestos = [];
        state.pjeFinanciacion = 0;
        state.montoBaseCreditoFinanciacion = 0;
        /* Seleccion de comprobantes para la NCR x financiación */
        state.creditoFinanciacionCliente = null;
        state.creditoFinanciacionComprobantes = [];

        /* Comisiones sobre presupuestos / ordenes de trabajo */
        state.presupuestoInternoId = 0;
        state.presupuestoInternoNumero = null;
        state.presupuestoInternoCliente = null;
        state.presupuestoInternoAccion = null;
        state.ordenTrabajoId = 0;
        state.ordenTrabajo = null;

        state.clienteSistemaCirculacionAbierta = false;

        state.cotizacionReadOnly = true;
        state.formularioReadOnly = false;
        state.opcionesFCEMyPime = false;

        state.paisId = params.paisId;

        switch (state.paisId) {
            case 1: /* Argentina */
                state.pjeAlicuotaIva = 21.0;
                state.montoNoGravadoVisible = true;
                state.formularioVisible = true;
                state.puntoVentaVisible = true;

                if ((/true/i).test(state.facturaExportacion)) {
                    state.formulario = 'E';
                    state.formularioReadOnly = true;
                    state.pjeAlicuotaIva = 0.0;

                    state.monedaId = 102;
                    state.moneda = {
                        id: 102,
                        nombre: 'DOLARES'
                    };
                    state.monedaNombre = 'DOLARES';

                    state.monedaPagoId = 102;
                    state.monedaPago = {
                        id: 102,
                        nombre: 'DOLARES'
                    };
                    state.monedaPagoNombre = 'DOLARES';

                    state.cotizacion = 1;
                    state.cotizacionReadOnly = false;
                }
                break;

            case 5: /* Chile */
                state.pjeAlicuotaIva = 19.0;
                state.montoNoGravadoVisible = false;
                state.formularioVisible = false;
                state.puntoVentaVisible = false;
                break;
        }
    },
    'SET_COMPROBANTES_TIPOS' (state, comprobantesTipos) {
        state.comprobantesTipos = comprobantesTipos;
        state.comprobantesTiposList = comprobantesTipos.map(comprobanteTipo => comprobanteTipo.nombre.trim());
    },

    'INICIALIZAR_CREDITO_DEBITO' (state, params) {
        if (params.ventaId) {
            state.ventaId = params.ventaId;
        } else {
            state.ventaId = 0;
        }
        state.venta = {
            montoGravado: 0,
            montoExento: 0,
            montoNoGravado: 0,
            montoIvaInscripto: 0,
        }
        if (params.creditoFinanciacion) {
            state.creditoFinanciacion = (/true/i).test(params.creditoFinanciacion);
        } else {
            state.creditoFinanciacion = false;
        }

        state.paisId = params.paisId;

        switch (state.paisId) {
            case 1: /* Argentina */
                state.pjeAlicuotaIva = 21.0;
                state.montoNoGravadoVisible = true;
                state.formularioVisible = true;
                state.puntoVentaVisible = true;
                break;

            case 5: /* Chile */
                state.pjeAlicuotaIva = 19.0;
                state.montoNoGravadoVisible = false;
                state.formularioVisible = false;
                state.puntoVentaVisible = false;
                break;
        }

        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaVencimiento = moment(new Date()).format('YYYY-MM-DD'),
        state.clienteId= 0;
        state.cliente= null;
        state.clienteNombre= null;
        state.clientePlazoPago = 0;
        state.condicionFiscalId= 0;
        state.condicionFiscalNombre= null;
        state.formaPagoId= 0;
        state.formaPago= null;
        state.formaPagoNombre= null;
        state.comprobanteTipoId= 0;
        state.comprobanteTipo= null;
        state.comprobanteTipoNombre= null;
        state.formulario = '';
        state.numeroPuntoVenta = 0;
        state.numero = 0;
        state.sistemaCirculacionAbierta = false;
        state.periodoAsociadoDesde = '1900-01-01',
        state.periodoAsociadoHasta = '1900-01-01',
        // state.monedaId = 0;
        // state.moneda = null;
        // state.monedaNombre = null;
        // state.cotizacion = 0;
        state.monedaId = 101;
        state.moneda = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';
        state.cotizacion = 1;
        state.total = 0;
        state.montoGravado= 0;
        state.montoExento= 0;
        state.montoNoGravado= 0;
        state.montoIvaInscripto= 0;
        state.monedaPagoId = 101;
        state.monedaPago = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaPagoNombre = 'PESOS';
        state.observaciones = '';
        state.renglones = [];
        state.renglonesDescripcion = [];
        state.rowVersion = null;

        state.certificadosServicio = false;
        state.facturaExportacion = false;
        state.certificadosCliente = [];

        state.pjeCreditoDebito = 0;

        state.comprobantesTipos =  [];
        state.comprobantesTiposList =  [];

        state.ventaReferencias = [];

        // state.creditoFinanciacion = false;
        state.creditoFinanciacionPresupuestos = [];
        state.creditoFeePresupuestos = [];
        state.pjeFinanciacion = 0;
        state.montoBaseCreditoFinanciacion = 0;
        /* Seleccion de comprobantes para la NCR x financiación */
        state.creditoFinanciacionCliente = null;
        state.creditoFinanciacionComprobantes = [];

        /* Comisiones sobre presupuestos / ordenes de trabajo */
        state.presupuestoInternoId = 0;
        state.presupuestoInternoNumero = null;
        state.presupuestoInternoCliente = null;
        state.presupuestoInternoAccion = null;
        state.ordenTrabajoId = 0;
        state.ordenTrabajo = null;

        state.clienteSistemaCirculacionAbierta = false;
        state.cotizacionReadOnly = true;
        state.formularioReadOnly = false;
        state.opcionesFCEMyPime = false;
    },
    'SET_VENTA_CREDITO_DEBITO'(state, venta) {
        state.venta = {
            montoGravado: venta.montoGravado,
            montoExento: venta.montoExento,
            montoNoGravado: venta.montoNoGravado,
            montoIvaInscripto: venta.montoIvaInscripto,
        }

        state.pjeAlicuotaIva = venta.pjeAlicuotaIva;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaVencimiento = moment(new Date()).format('YYYY-MM-DD'),
        state.clienteId= venta.clienteId;
        state.clienteNombre= venta.cliente.trim();
        state.clientePlazoPago = 0;
        state.condicionFiscalId= venta.condicionFiscalId;
        state.condicionFiscalNombre= venta.condicionFiscal.trim();
        state.formaPagoId= venta.formaPagoId;
        state.formaPagoNombre= venta.formaPago.trim();
        state.formulario = venta.formulario;
        state.numeroPuntoVenta = venta.numeroPuntoVenta;
        state.monedaId = venta.monedaId;
        state.monedaNombre = venta.moneda.trim();
        state.cotizacion = venta.cotizacion;
        state.monedaPagoId = venta.monedaPagoId;
        state.monedaPagoNombre = venta.monedaPago.trim();

        state.total = 0;

        /* Asignamos el primer tipo de comprobante de la lista */
        if (state.comprobantesTipos) {
            if (state.comprobantesTipos.length != 0) {
                state.comprobanteTipo= state.comprobantesTipos[0];
                state.comprobanteTipoId= state.comprobanteTipo.id;
                state.comprobanteTipoNombre= state.comprobanteTipo.nombre.trim();
            }
        }

        if (state.comprobanteTipo) {
            state.formularioVisible = state.comprobanteTipo.requiereFormulario;
            state.puntoVentaVisible = state.comprobanteTipo.requierePuntoVenta;
        }

        /* Comisiones sobre presupuestos / ordenes de trabajo */
        state.presupuestoInternoId = venta.presupuestoInternoId;
        state.ordenTrabajoId = venta.ordenTrabajoId;

        state.cotizacionReadOnly = state.monedaId == 102? false : true;
        state.formularioReadOnly = false;
        state.opcionesFCEMyPime = false;
    },
    'SET_CREDITO'(state, comprobante) {
        state.pjeAlicuotaIva = comprobante.pjeAlicuotaIva;
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaVencimiento = moment(new Date()).format('YYYY-MM-DD'),
        state.clienteId= comprobante.clienteId;
        state.clienteNombre= comprobante.cliente.trim();
        state.clientePlazoPago = 0;
        state.condicionFiscalId= comprobante.condicionFiscalId;
        state.condicionFiscalNombre= comprobante.condicionFiscal.trim();
        state.formaPagoId= comprobante.formaPagoId;
        state.formaPagoNombre= comprobante.formaPago.trim();
        state.formulario = comprobante.formulario;
        state.comprobanteTipoId= comprobante.comprobanteTipoId;
        state.comprobanteTipo= {
            id: comprobante.comprobanteTipoId,
            nombre: comprobante.comprobanteTipo.trim()
        };
        state.comprobanteTipoNombre= comprobante.comprobanteTipo.trim();
        state.numeroPuntoVenta = comprobante.numeroPuntoVenta;
        state.monedaId = comprobante.monedaId;
        state.moneda = {
            id: comprobante.monedaId,
            nombre: comprobante.moneda.trim()
        }
        state.monedaNombre = comprobante.moneda.trim();
        state.cotizacion = comprobante.cotizacion;
        state.total = comprobante.total;
        state.montoGravado= comprobante.montoGravado;
        state.montoExento= comprobante.montoExento;
        state.montoNoGravado= comprobante.montoNoGravado;
        state.montoIvaInscripto= comprobante.montoIvaInscripto;
        state.monedaPagoId = comprobante.monedaPagoId;
        state.monedaPago = {
            id: comprobante.monedaPagoId,
            nombre: comprobante.monedaPago.trim()
        }
        state.monedaPagoNombre = comprobante.monedaPago.trim();

        state.creditoFinanciacionPresupuestos = comprobante.creditoFinanciacionPresupuestos;
        state.creditoFeePresupuestos = comprobante.creditoFeePresupuestos;

        /* Parámetros para el cálculo del crédito por financiación */
        state.pjeFinanciacion = comprobante.pjeFinanciacion;
        state.montoBaseCreditoFinanciacion = 0;
        if (state.creditoFinanciacionPresupuestos) {
            state.montoBaseCreditoFinanciacion = state.creditoFinanciacionPresupuestos
                .reduce((montoBase, presupuesto) => montoBase + presupuesto.importeCertificado, 0);
        }

        state.cotizacionReadOnly = state.monedaId == 102? false : true;
        state.formularioReadOnly = false;

        state.ventaReferencias = comprobante.ventasReferencias;
        if (comprobante.ventasReferencias) {
            /* Calculamos los totales de los comprobantes de referencia */
            let montoGravado = comprobante.ventasReferencias
                .reduce((monto, venta) => monto + parseFloat(venta.montoGravado), 0);
            let montoExento = comprobante.ventasReferencias
                .reduce((monto, venta) => monto + parseFloat(venta.montoExento), 0);
            let montoNoGravado = comprobante.ventasReferencias
                .reduce((monto, venta) => monto + parseFloat(venta.montoNoGravado), 0);
            let montoIvaInscripto = comprobante.ventasReferencias
                .reduce((monto, venta) => monto + parseFloat(venta.montoIvaInscripto), 0);

            state.venta = {
                montoGravado,
                montoExento,
                montoNoGravado,
                montoIvaInscripto,
            }
        }
    },
    'INICIALIZAR_CREDITO_FINANCIACION_COMPROBANTES'(state) {
        state.creditoFinanciacionComprobantes = [];
    },
    'SET_CREDITO_FINANCIACION_COMPROBANTES'(state, comprobantes) {
        state.creditoFinanciacionComprobantes = comprobantes.map(comprobante => ({
            ...comprobante,
            selected: false
        }) );
    },

    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;

        if (cliente) {
            state.clienteId = cliente.id? cliente.id : 0;
            state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
            state.clientePlazoPago = cliente.plazoPago? cliente.plazoPago : 0;
            state.clienteSistemaCirculacionAbierta = cliente.sistemaCirculacionAbierta? (/true/i).test(cliente.sistemaCirculacionAbierta) : false;
        } else {
            state.clienteId = 0;
            state.clienteNombre = null;
            state.clientePlazoPago = 0;
            state.clienteSistemaCirculacionAbierta = false;
        }

        /* Actualizamos la fecha de vencimiento */
        state.fechaVencimiento = moment(state.fechaComprobante)
            .add(state.clientePlazoPago, 'days').format('YYYY-MM-DD');

        let condicionFiscal = cliente? cliente.condicionFiscalId : 0;

        switch (state.paisId) {
            case 1: /* Argentina */
                if ((/true/i).test(state.facturaExportacion)) {
                    state.formulario = 'E';
                    state.formularioReadOnly = true;
                    state.pjeAlicuotaIva = 0.0;
                } else {
                    state.pjeAlicuotaIva = 21.0;
                    switch (condicionFiscal) {
                        case 1:
                            state.formulario = 'A';
                            break;
                        case 2:
                        case 4:
                            state.formulario = 'B';
                            break;

                        default:
                            state.formulario = '';
                            break;
                    }
                    state.formularioReadOnly = false;
                }

                switch (state.comprobanteTipoId) {
                    case 6:
                    case 7:
                    case 8:
                        state.sistemaCirculacionAbierta = (/true/i).test(state.clienteSistemaCirculacionAbierta);
                        state.opcionesFCEMyPime = true;
                        break;

                    default:
                        state.sistemaCirculacionAbierta = false;
                        state.opcionesFCEMyPime = false;
                        break;
                }
                break;

            case 5: /* Chile */
                state.pjeAlicuotaIva = 19.0;
                state.formulario = '';
                state.formularioReadOnly = true;
                state.sistemaCirculacionAbierta = false;
                state.opcionesFCEMyPime = false;
                break;
        }

        let formaPagoId = cliente? cliente.formaPagoId : 0;
        if (formaPagoId != 0) {
            state.formaPagoId = formaPagoId;
            state.formaPago = {
                id: formaPagoId,
                nombre: cliente.formaPago.trim()
            }
            state.formaPagoNombre = cliente.formaPago.trim();
        } else {
            state.formaPagoId = 0;
            state.formaPago = null;
            state.formaPagoNombre = null;
        }

        /* Inicializamos los renglones */
        state.renglones = [];
        state.renglonesDescripcion = [];
        state.certificadosCliente = [];

        if (!(/true/i).test(state.certificadosServicio)) {
            state.renglonesDescripcion.push({
                renglonNumero: 1,
                descripcion: '',
                importe: 0,
            });
        }
    },
    'SET_FORMA_PAGO'(state, formaPago) {
        state.formaPagoId = formaPago? formaPago.id : 0;
        state.formaPago = formaPago;
        state.formaPagoNombre = formaPago? formaPago.nombre.trim() : null;
    },
    'SET_COMPROBANTE_TIPO'(state, comprobanteTipo) {
        state.comprobanteTipoId = comprobanteTipo? comprobanteTipo.id : 0;
        state.comprobanteTipo = comprobanteTipo;
        state.comprobanteTipoNombre = comprobanteTipo? comprobanteTipo.nombre.trim() : null;

        /* Configuracion segun el tipo de comprobante */
        if ((/true/i).test(state.comprobanteTipo.numeracionAutomatica)) {
            state.numero = 0;
        }
        state.formularioVisible = state.comprobanteTipo.requiereFormulario;
        state.puntoVentaVisible = state.comprobanteTipo.requierePuntoVenta;

        /* Definimos la alicuota a aplicar a partir del tipo de comprobante */
        switch(state.comprobanteTipoId) {
            case 1: /* FAC (Arg) */
            case 2: /* NCR (Arg) */
            case 3: /* NDB (Arg) */
            case 6: /* FCE (Arg) */
            case 7: /* NCE (Arg) */
            case 8: /* NDE (Arg) */
                state.pjeAlicuotaIva = 21.0;
                break

            case 14: /* FE (Chile) */
            case 15: /* NCE (Chile) */
            case 16: /* NDE (Chile) */
                state.pjeAlicuotaIva = 19.0;
                break;

            case 17: /* FEE (Chile) */
            case 18: /* NCEE (Chile) */
            case 19: /* NDEE (Chile) */
            case 21: /* NCB (Chile) */
            case 23: /* NCBC (Chile) */
                state.pjeAlicuotaIva = 0.0;
                break;

            default:
                state.pjeAlicuotaIva = 21.0;
                break
        }

        /* Si corresponde a una factura con renglones */
        if ((/true/i).test(state.certificadosServicio)) {
            calcularTotalesRenglones(state);
            setRenglonesDescripcion(state);
        } else {
            calcularMontosTotal(state);
            setImporteRenglon(state);
        }

        if (state.paisId == 1) {
            switch (state.comprobanteTipoId) {
                case 6:
                case 7:
                case 8:
                    state.sistemaCirculacionAbierta = (/true/i).test(state.clienteSistemaCirculacionAbierta);
                    state.opcionesFCEMyPime = true;
                    break;

                default:
                    state.sistemaCirculacionAbierta = false;
                    state.opcionesFCEMyPime = false;
                    break;
            }
        }
    },
    'SET_MONEDA'(state, moneda) {
        state.monedaId = moneda? moneda.id : 0;
        state.moneda = moneda;
        state.monedaNombre = moneda? moneda.nombre.trim() : null;

        if (state.monedaId == 101) {
            state.cotizacion = parseFloat(1);
            state.cotizacionReadOnly = true;
        } else if (state.monedaId == 102) {
            if ((/true/i).test(state.facturaExportacion)) {
                state.cotizacion = parseFloat(state.cotizacionDolar);
            }
            state.cotizacionReadOnly = false;
        }

        /* Si corresponde a una factura con renglones */
        if ((/true/i).test(state.certificadosServicio)) {
            inicializarTotales(state);

            state.renglones = state.certificadosCliente.map(certificadoServicio => ({
                id: certificadoServicio.id,
                fechaRegistro: certificadoServicio.fechaRegistro,
                accion: certificadoServicio.accion,
                numeroOrdenCompra: certificadoServicio.numeroOrdenCompra,
                monedaId: certificadoServicio.monedaId,
                moneda: certificadoServicio.moneda,
                cotizacion: certificadoServicio.importe,
                saldo: certificadoServicio.saldo,
                importe: certificadoServicio.importe,
                seleccionado: Boolean(false),
                seleccionDisabled: certificadoServicio.monedaId == state.monedaId? false : true,
                _rowVariant: certificadoServicio.monedaId == state.monedaId? '' : 'danger'
            }));

            setRenglonesDescripcion(state);

            state.certificadosSeleccionados = false;
            state.certificadosSeleccionadosIndeterminado = false;
        }
    },
    'SET_MONEDA_PAGO'(state, moneda) {
        state.monedaPago = moneda;
        if (moneda) {
            state.monedaPagoId = moneda.id? moneda.id : 0;
            state.monedaPagoNombre = moneda.nombre? moneda.nombre.trim() : null;
        } else {
            state.monedaPagoId = 0;
            state.monedaPagoNombre = null;
        }
    },
    'SET_COTIZACION_DOLAR'(state, cotizacionDolar) {
        state.cotizacion = parseFloat(cotizacionDolar);
        state.cotizacionDolar = parseFloat(cotizacionDolar);
    },
    'CALCULAR_FECHA_VENCIMIENTO'(state) {
        state.fechaVencimiento = moment(state.fechaComprobante)
            .add(state.clientePlazoPago, 'days').format('YYYY-MM-DD');
    },
    'SET_CERTIFICADOS' (state, certificadosServicio) {
        state.renglones = [];

        inicializarTotales(state);

        /* Certificados con saldo del cliente */
        state.certificadosCliente = certificadosServicio;

        state.renglones = state.certificadosCliente.map(certificadoServicio => ({
            id: certificadoServicio.id,
            fechaRegistro: certificadoServicio.fechaRegistro,
            accion: certificadoServicio.accion,
            numeroOrdenCompra: certificadoServicio.numeroOrdenCompra,
            monedaId: certificadoServicio.monedaId,
            moneda: certificadoServicio.moneda,
            cotizacion: certificadoServicio.importe,
            saldo: certificadoServicio.saldo,
            importe: certificadoServicio.importe,
            provincias: certificadoServicio.provincias,
            seleccionado: Boolean(false),
            seleccionDisabled: certificadoServicio.monedaId == state.monedaId? false : true,
            _rowVariant: certificadoServicio.monedaId == state.monedaId? '' : 'danger'
        }));

        setRenglonesDescripcion(state);

        state.certificadosSeleccionados = false;
        state.certificadosSeleccionadosIndeterminado = false;
    },
    'CERTIFICADO_SELECCIONADO' (state) {
        calcularTotalesRenglones(state);

        setRenglonesDescripcion(state);

        /* Actualizamos el estado del check global */
        let existsCertificadoSeleccionado = false;
        let existsCertificadoNoSeleccionado = false;

        let certificadoSeleccionado = state.renglones
            .find(renglon => (/true/i).test(renglon.seleccionado) == Boolean(true));
        if (certificadoSeleccionado) {
            existsCertificadoSeleccionado = true;
        }

        /* Validamos segun la moneda del comprobante */
        let certificadoNoSeleccionado = state.renglones
            .find(renglon => (/true/i).test(renglon.seleccionado) == Boolean(false)
                & renglon.monedaId == state.monedaId);
        if (certificadoNoSeleccionado) {
            existsCertificadoNoSeleccionado = true;
        }

        state.certificadosSeleccionados = existsCertificadoSeleccionado;
        state.certificadosSeleccionadosIndeterminado = existsCertificadoSeleccionado & existsCertificadoNoSeleccionado ? true : false;
    },
    'ACTUALIZAR_SELECCION_CERTIFICADOS' (state) {
        state.renglones.forEach(renglon => {
            /* Segun la moneda del comprobante */
            if (renglon.monedaId == state.monedaId) {
                if ((/true/i).test(state.certificadosSeleccionados)) {
                    renglon.seleccionado = false;
                } else {
                    renglon.seleccionado = true;
                }
            }
        });

        state.certificadosSeleccionados = !state.certificadosSeleccionados;
        state.certificadosSeleccionadosIndeterminado = false;

        calcularTotalesRenglones(state);
        setRenglonesDescripcion(state);
    },
    'CALCULAR_MONTOS_TOTAL' (state) {
        calcularMontosTotal(state);
    },
    'CALCULAR_MONTO_IVA' (state) {
        calcularMontosIva(state);
    },
    'SET_IMPORTE_RENGLON' (state) {
        setImporteRenglon(state);
    },
    'ACTUALIZAR_TOTAL' (state) {
        actualizarTotal(state);
    },
    'CALCULAR_TOTALES' (state) {
        calcularTotalesRenglones(state);
        setRenglonesDescripcion(state);
    },
    'CALCULAR_TOTALES_CREDITO_DEBITO' (state) {
        let montoGravado = 0;
        let montoExento = 0;
        let montoNoGravado = 0;
        let montoIvaInscripto = 0;

        if (state.pjeCreditoDebito != 0) {
            montoGravado = parseFloat(state.venta.montoGravado) * parseFloat(state.pjeCreditoDebito) / 100;
            montoExento = parseFloat(state.venta.montoExento) * parseFloat(state.pjeCreditoDebito) / 100;
            montoNoGravado = parseFloat(state.venta.montoNoGravado) * parseFloat(state.pjeCreditoDebito) / 100;
            montoIvaInscripto = parseFloat(state.venta.montoIvaInscripto) * parseFloat(state.pjeCreditoDebito) / 100;
        }

        state.total = roundNumber((montoGravado + montoExento + montoNoGravado + montoIvaInscripto) * state.cotizacion, 2);
        // state.total = roundNumber(montoGravado + montoExento + montoNoGravado + montoIvaInscripto, 2);
        state.montoGravado= roundNumber(montoGravado, 2);
        state.montoExento= roundNumber(montoExento, 2);
        state.montoNoGravado= roundNumber(montoNoGravado, 2);
        state.montoIvaInscripto= roundNumber(montoIvaInscripto, 2);
    },
    'ADD_RENGLON_DESCRIPCION' (state) {
        let renglonesDescripcion = state.renglonesDescripcion.length;
        const renglonDescripcion = {
            renglonNumero: renglonesDescripcion + 1,
            descripcion: '',
            importe: 0,
        }
        state.renglonesDescripcion.push(renglonDescripcion);
    },
    'VALIDAR_RENGLON_DESCRIPCION' (state) {
        validarRenglonesDescripcion(state.renglonesDescripcion);
    },
    'CALCULAR_TOTALES_CREDITO_FINANCIACION' (state) {
        calcularTotalesCreditoFinanciacion(state);
    },
    'SET_PRESUPUESTO' (state, params) {
        state.presupuestoInternoId = params.presupuestoInterno? params.presupuestoInterno.id : 0;
        state.presupuestoInternoNumero = params.presupuestoInterno? params.presupuestoInterno.presupuestoNumero : '';
        state.presupuestoInternoCliente = params.presupuestoInterno? params.presupuestoInterno.cliente.trim() : '';
        state.presupuestoInternoAccion = params.presupuestoInterno? params.presupuestoInterno.accion.trim() : '';
        state.ordenTrabajoId = params.ordenTrabajo? params.ordenTrabajo.id : 0;
        state.ordenTrabajo = params.ordenTrabajo? params.ordenTrabajo.rubroTrabajo.trim() : '';
    },

    'INICIALIZAR_DATOS' (state) {
      state.ventaDatos = [];
      state.ventaRenglonesDatos = [];
      state.ventaRenglonesDescripcionDatos = [];
      state.ventaAsociadasDatos = [];
      state.ventaReferenciasDatos = [];
      state.ventaDatosMoneda = '';
      state.ventaNegociacionDatos = [];
    },
    'SET_VENTA_DATOS' (state, params) {
      state.ventaDatos = params.ventaDatos;
      state.ventaRenglonesDatos = params.ventaRenglonesDatos;
      state.ventaRenglonesDescripcionDatos = params.ventaRenglonesDescripcionDatos;
      state.ventaAsociadasDatos = params.ventaAsociadasDatos;
      state.ventaReferenciasDatos = params.ventaReferenciasDatos;
      state.ventaDatosMoneda = params.moneda;
      state.ventaNegociacionDatos = params.ventaNegociacionDatos;
    },
    'SET_VENTA_DATOS_RPT' (state, params) {
      state.ventaDatosRpt = params.ventaDatos;
      state.ventaRenglonesDatosRpt = params.ventaRenglonesDatos;
      state.ventaRenglonesDescripcionDatosRpt = params.ventaRenglonesDescripcionDatos;
    },
};

function setRenglonesDescripcion(state) {
    let renglonNumero = 0;

    state.renglonesDescripcion = [];

    state.renglones.forEach(renglon => {
        if ((/true/i).test(renglon.seleccionado) == Boolean(true)) {
            renglonNumero++;
            let renglonDescripcion = {
                renglonNumero: renglonNumero,
                descripcion: renglon.numeroOrdenCompra,
                importe: renglon.importe,
                _rowVariant: ''
            }
            state.renglonesDescripcion.push(renglonDescripcion);

            /* Si el presupuesto tiene provincias asociadas, agregamos el renglon */
            if (renglon.provincias) {
                if (renglon.provincias != '') {
                    if (renglon.provincias.length > 100) {
                        let provincias = renglon.provincias.split(',');
                        let renglonProvincias = '';
                        provincias.forEach(provincia => {
                            let renglonDescripcion = new String().concat(renglonProvincias.trim(), ',', provincia.trim());

                            if (renglonProvincias.length > 100) {
                                renglonNumero++;
                                let renglonDescripcion = {
                                    renglonNumero: renglonNumero,
                                    descripcion: renglonProvincias.trim(),
                                    importe: 0,
                                    _rowVariant: ''
                                }
                                state.renglonesDescripcion.push(renglonDescripcion);

                                renglonProvincias = provincia.trim();
                            } else {
                                if (renglonProvincias.trim() == '') {
                                    renglonProvincias = provincia.trim();
                                } else {
                                    renglonProvincias = new String().concat(renglonProvincias.trim(), ',', provincia.trim());
                                }
                            }
                        });

                        if (renglonProvincias.trim() != '') {
                            renglonNumero++;
                            let renglonDescripcion = {
                                renglonNumero: renglonNumero,
                                descripcion: renglonProvincias.trim(),
                                importe: 0,
                                _rowVariant: ''
                            }
                            state.renglonesDescripcion.push(renglonDescripcion);
                        }
                    } else {
                        renglonNumero++;
                        let renglonDescripcion = {
                            renglonNumero: renglonNumero,
                            descripcion: renglon.provincias,
                            importe: 0,
                            _rowVariant: ''
                        }
                        state.renglonesDescripcion.push(renglonDescripcion);
                    }
                }
            }
        }
    });
}

function setImporteRenglon(state) {
    let importeRenglon = parseFloat(state.montoGravado)
            + parseFloat(state.montoNoGravado)
            + parseFloat(state.montoExento);

    // if (state.monedaId == 102) {
    //     importeRenglon = parseFloat(state.total);
    // } else {
    //     importeRenglon = parseFloat(state.montoGravado)
    //         + parseFloat(state.montoNoGravado)
    //         + parseFloat(state.montoExento);
    // }

    if (state.renglonesDescripcion.length != 0) {
        let renglon = state.renglonesDescripcion[0];

        renglon.importe = importeRenglon;
    }
}

function inicializarTotales(state) {
    console.log('inicializarTotales');
    state.total = 0;

    state.montoGravado = 0;
    state.montoExento = 0;
    state.montoNoGravado = 0;
    state.montoIvaInscripto = 0;

    state.montoGravadoLocal = 0;
    state.montoExentoLocal = 0;
    state.montoNoGravadoLocal = 0;
    state.montoIvaInscriptoLocal = 0;
}

function calcularTotalesRenglones(state) {
    let montoGravado = 0;
    let montoExento = 0;
    let montoNoGravado = 0;
    let montoIvaInscripto = 0;

    // console.log('renglones ', state.renglones);

    let montoBase = roundNumber(state.renglones
        .reduce((montoBase, certificado) => montoBase + ( certificado.seleccionado ? certificado.importe : 0 ), 0), 2);
    
    // console.log('montoBase: ', montoBase);

    if ((/true/i).test(state.facturaExportacion)) {
        montoExento = montoBase;
    } else {
        let comprobanteTipoId = 0;
        if (state.comprobanteTipo) {
            comprobanteTipoId = state.comprobanteTipo.id;
        }

        if (state.formulario != null) {
            switch(comprobanteTipoId) {
                case 1: /* FAC (Arg) */
                case 2: /* NCR (Arg) */
                case 3: /* NDB (Arg) */
                case 6: /* FCE (Arg) */
                case 7: /* NCE (Arg) */
                case 8: /* NDE (Arg) */
                    montoGravado = montoBase;
                    montoIvaInscripto = montoBase * parseFloat(state.pjeAlicuotaIva) / 100;
                    break

                case 14: /* FE (Chile) */
                case 15: /* NCE (Chile) */
                case 16: /* NDE (Chile) */
                    montoGravado = montoBase;
                    montoIvaInscripto = montoBase * parseFloat(state.pjeAlicuotaIva) / 100;
                    break;

                case 17: /* FEE (Chile) */
                case 18: /* NCEE (Chile) */
                case 19: /* NDEE (Chile) */
                case 21: /* NCB (Chile) */
                case 23: /* NCBC (Chile) */
                    montoExento = montoBase;
                    break;

                default:
                    montoNoGravado = montoBase;
                    break
            }
        }
    }

    /* Total en la moneda seleccionada */
    state.total = roundNumber(montoGravado + montoExento + montoNoGravado + montoIvaInscripto, 2);

    console.log('total: ', state.total, montoGravado, montoExento, montoNoGravado, montoIvaInscripto);

    /* Montos discriminados según la moneda del comprobante */
    state.montoGravado = roundNumber(montoGravado, 2);
    state.montoExento = roundNumber(montoExento, 2);
    state.montoNoGravado = roundNumber(montoNoGravado, 2);
    state.montoIvaInscripto = roundNumber(montoIvaInscripto, 2);

    /* Montos discriminados en pesos según la cotización */
    let cotizacion = 1;
    if (state.monedaId != 101) {
        if (state.cotizacion != '') {
            if (!isNaN(state.cotizacion)) {
                cotizacion = parseFloat(state.cotizacion);
            }
        }
    }
    state.montoGravadoLocal = roundNumber(state.montoGravado * cotizacion, 2);
    state.montoExentoLocal = roundNumber(state.montoExento * cotizacion, 2);
    state.montoNoGravadoLocal = roundNumber(state.montoNoGravado * cotizacion, 2);
    state.montoIvaInscriptoLocal = roundNumber(state.montoIvaInscripto * cotizacion, 2);
}

function calcularTotalesCreditoFinanciacion(state) {
    let montoGravado = 0;
    let montoExento = 0;
    let montoNoGravado = 0;
    let montoIvaInscripto = 0;

    let montoBase = roundNumber(parseFloat(state.montoBaseCreditoFinanciacion) * parseFloat(state.pjeFinanciacion) / 100, 2);

    let comprobanteTipoId = 0;
    if (state.comprobanteTipo) {
        comprobanteTipoId = state.comprobanteTipo.id;
    }

    if (state.formulario != null) {
        switch(comprobanteTipoId) {
            case 2: /* NCR (Arg) */
            case 3: /* NDB (Arg) */
            case 7: /* NCE (Arg) */
            case 8: /* NDE (Arg) */
                montoGravado = montoBase;
                montoIvaInscripto = montoBase * parseFloat(state.pjeAlicuotaIva) / 100;
                // if (state.formulario.toUpperCase() == 'A' || state.formulario.toUpperCase() == 'M') {
                //     montoGravado = montoBase;
                //     montoIvaInscripto = montoBase * parseFloat(state.pjeAlicuotaIva) / 100;
                // } else if (state.formulario.toUpperCase() == 'B') {
                //     montoGravado = montoBase;
                // } else if (state.formulario.toUpperCase() == 'C') {
                //     montoNoGravado = montoBase;
                // }
                break

            case 15: /* NCE (Chile) */
            case 16: /* NDE (Chile) */
                montoGravado = montoBase;
                montoIvaInscripto = montoBase * parseFloat(state.pjeAlicuotaIva) / 100;
                break;

            case 18: /* NCEE (Chile) */
            case 19: /* NDEE (Chile) */
            case 23: /* NCBC (Chile) */
                montoExento = montoBase;
                break;

            default:
                montoNoGravado = montoBase;
                break
        }
    }

    // state.total = roundNumber((parseFloat(montoGravado) + parseFloat(montoExento)
    //     + parseFloat(montoNoGravado) + parseFloat(montoIvaInscripto)) * parseFloat(state.cotizacion), 2);

    /* Total en la moneda del comprobante */
    state.total = roundNumber((parseFloat(montoGravado)
        + parseFloat(montoExento)
        + parseFloat(montoNoGravado)
        + parseFloat(montoIvaInscripto)), 2);

    /* Montos discriminados según la moneda del comprobante */
    state.montoGravado = roundNumber(montoGravado, 2);
    state.montoExento = roundNumber(montoExento, 2);
    state.montoNoGravado = roundNumber(montoNoGravado, 2);
    state.montoIvaInscripto = roundNumber(montoIvaInscripto, 2);

    /* Montos discriminados en pesos según la cotización */
    let cotizacion = 1;
    if (state.monedaId != 101) {
        if (state.cotizacion != '') {
            if (!isNaN(state.cotizacion)) {
                cotizacion = parseFloat(state.cotizacion);
            }
        }
    }
    state.montoGravadoLocal = roundNumber(state.montoGravado * cotizacion, 2);
    state.montoExentoLocal = roundNumber(state.montoExento * cotizacion, 2);
    state.montoNoGravadoLocal = roundNumber(state.montoNoGravado * cotizacion, 2);
    state.montoIvaInscriptoLocal = roundNumber(state.montoIvaInscripto * cotizacion, 2);
}

function actualizarTotal(state) {
    console.log('actualizarTotal - montoGravado: ', state.montoGravado);
    console.log('actualizarTotal - montoExento: ', state.montoExento);
    console.log('actualizarTotal - montoNoGravado: ', state.montoNoGravado);
    console.log('actualizarTotal - montoIvaInscripto: ', state.montoIvaInscripto);
    state.total = roundNumber((parseFloat(state.montoGravado)
        + parseFloat(state.montoExento)
        + parseFloat(state.montoNoGravado)
        + parseFloat(state.montoIvaInscripto)), 2);

    // state.total = roundNumber((parseFloat(state.montoGravado)
    //     + parseFloat(state.montoExento)
    //     + parseFloat(state.montoNoGravado)
    //     + parseFloat(state.montoIvaInscripto))
    //     * parseFloat(state.cotizacion), 2);
}

function calcularMontosTotal(state) {
    let montoGravado = 0;
    let montoExento = 0;
    let montoNoGravado = 0;
    let montoIvaInscripto = 0;

    let montoTotal = 0;

    if (state.total != '') {
        if (!isNaN(state.total)) {
            montoTotal = parseFloat(state.total);
        }
    }

    console.log('calcularMontosTotal - montoTotal: ', montoTotal, state.total);
    // /* Calculamos el total según la cotización del comprobante */
    // if (state.monedaId != 101) {
    //     if (state.cotizacion != '') {
    //         if (!isNaN(state.cotizacion)) {
    //             montoTotal = parseFloat(state.cotizacion) * montoTotal;
    //         }
    //     }
    // }

    let comprobanteTipoId = 0;
    if (state.comprobanteTipo) {
        comprobanteTipoId = state.comprobanteTipo.id;
    }

    console.log('calcularMontosTotal - comprobanteTipoId: ', comprobanteTipoId);

    if (state.formulario != null) {
        switch(comprobanteTipoId) {
            case 1: /* FAC */
            case 2: /* NCR */
            case 3: /* NDB */
            case 6: /* FCE */
            case 7: /* NCE */
            case 8: /* NDE */
                montoIvaInscripto = montoTotal - ( montoTotal / (1 + parseFloat(state.pjeAlicuotaIva) / 100));
                montoGravado = montoTotal - montoIvaInscripto;
                break;

            case 11: /* FEX */
                montoExento = montoTotal;
                break;

            case 14: /* FE (Chile) */
            case 15: /* NCE (Chile) */
            case 16: /* NDE (Chile) */
                montoIvaInscripto = montoTotal - ( montoTotal / (1 + parseFloat(state.pjeAlicuotaIva) / 100));
                montoGravado = montoTotal - montoIvaInscripto;
                break;

            case 17: /* FEE (Chile) */
            case 18: /* NCEE (Chile) */
            case 19: /* NDEE (Chile) */
            case 21: /* NCB (Chile) */
            case 23: /* NCBC (Chile) */
                montoExento = montoTotal;
                break;
        }
    }

    /* Montos discriminados segun la moneda seleccionada */
    state.montoGravado = roundNumber(montoGravado, 2);
    state.montoExento = roundNumber(montoExento, 2);
    state.montoNoGravado = roundNumber(montoNoGravado, 2);
    state.montoIvaInscripto = roundNumber(montoIvaInscripto, 2);

    /* Montos discriminados en pesos según la cotización */
    let cotizacion = 1;
    if (state.monedaId != 101) {
        if (state.cotizacion != '') {
            if (!isNaN(state.cotizacion)) {
                cotizacion = parseFloat(state.cotizacion);
            }
        }
    }
    state.montoGravadoLocal = roundNumber(state.montoGravado * cotizacion, 2);
    state.montoExentoLocal = roundNumber(state.montoExento * cotizacion, 2);
    state.montoNoGravadoLocal = roundNumber(state.montoNoGravado * cotizacion, 2);
    state.montoIvaInscriptoLocal = roundNumber(state.montoIvaInscripto * cotizacion, 2);
}

function calcularMontosIva(state) {
    let montoGravado = 0;
    let montoIvaInscripto = 0;

    if (!isNaN(state.montoGravado) & state.montoGravado != '') {
        montoGravado = parseFloat(state.montoGravado);

        let comprobanteTipoId = 0;
        if (state.comprobanteTipo) {
            comprobanteTipoId = state.comprobanteTipo.id;
        }

        if (state.formulario != null) {
            switch(comprobanteTipoId) {
                case 1: /* FAC */
                case 2: /* NCR */
                case 3: /* NDB */
                case 6: /* FCE */
                case 7: /* NCE */
                case 8: /* NDE */
                    montoIvaInscripto = parseFloat(montoGravado) * parseFloat(state.pjeAlicuotaIva) / 100;
                    // if (state.formulario.toUpperCase() == 'A' || state.formulario.toUpperCase() == 'M') {
                    //     montoIvaInscripto = parseFloat(montoGravado) * parseFloat(state.pjeAlicuotaIva) / 100;
                    // }
                    break;

                case 14: /* FE (Chile) */
                case 15: /* NCE (Chile) */
                case 16: /* NDE (Chile) */
                    montoIvaInscripto = parseFloat(montoGravado) * parseFloat(state.pjeAlicuotaIva) / 100;
                    break;

                default:
                    break;
            }
        }
    }

    /* Monto discriminado según la moneda seleccionada */
    state.montoIvaInscripto = roundNumber(montoIvaInscripto, 2);

    /* Monto discriminado en pesos según la cotización */
    let cotizacion = 1;
    if (state.monedaId != 101) {
        if (state.cotizacion != '') {
            if (!isNaN(state.cotizacion)) {
                cotizacion = parseFloat(state.cotizacion);
            }
        }
    }
    state.montoIvaInscriptoLocal = roundNumber(state.montoIvaInscripto * cotizacion, 2);
}

function validarRenglonesDescripcion(renglones) {
    let valid = true;
    let descripcion = false
    renglones.forEach(renglon => {
        if (renglon.descripcion.trim() != '') {
            descripcion = true;
        }
        if (isNaN(renglon.importe) || renglon.importe === '') {
            renglon._rowVariant = 'danger';
            valid = false;
        } else {
            renglon._rowVariant = '';
        }
    });
    if (descripcion == false) {
        valid = false;
    }
    return valid;
}

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
        sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
}

const getters = {
    getField,

    ventaDatosRpt (state) {
        return state.ventaDatosRpt;
    },
    ventaRenglonesDatosRpt (state) {
        return state.ventaRenglonesDatosRpt;
    },
    ventaRenglonesDescripcionDatosRpt (state) {
        return state.ventaRenglonesDescripcionDatosRpt;
    },
};

const actions = {
    inicializar ( { commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }
            params.paisId = paisId;

            commit('INICIALIZAR_VENTA', params);

            let queryString = '';
            if ((/true/i).test(params.facturaExportacion)) {
                queryString = '?exportacion=true';
            } else {
                if ((/true/i).test(params.certificadosServicio)) {
                    queryString = '?certificadosServicio=true';
                }
            }

            if ((/true/i).test(params.facturaExportacion)) {
                /* Recuperamos los tipos de comprobante */
                apiAxios.get('ventas/comprobantes-tipos' + queryString)
                    .then(res => {
                        commit('SET_COMPROBANTES_TIPOS', res.data);
                        return apiAxios.get('facturaelectronica/cotizacion-dolar');
                    })
                    .then(res => {
                        commit('SET_COTIZACION_DOLAR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                /* Recuperamos los tipos de comprobante */
                apiAxios.get('ventas/comprobantes-tipos' + queryString)
                    .then(res => {
                        commit('SET_COMPROBANTES_TIPOS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
            // if ((/true/i).test(params.facturaExportacion)) {
            //     apiAxios.get('facturaelectronica/cotizacion-dolar')
            //         .then(res => {
            //             commit('SET_COTIZACION_DOLAR', res.data);
            //             resolve();
            //         })
            //         .catch(error => reject(helpers.methods.getErrorMessage(error)));
            // } else {
            //     resolve();
            // }
        })
    },
    setCliente: ({ commit, state }, cliente) => {
        return new Promise((resolve, reject) => {
            commit('SET_CLIENTE', cliente);

            if ((/true/i).test(state.certificadosServicio)) {
                if (cliente) {
                    /* Recuperamos los certificados con saldo del cliente */
                    let queryString = '?clienteId=' + cliente.id;

                    apiAxios.get('certificadosservicio/facturacion' + queryString )
                        .then(res => {
                            commit('SET_CERTIFICADOS', res.data);
                            resolve();
                        })
                        .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        })
    },
    inicializarCreditoDebito ( { commit, rootState }, ventaId ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }

            let params = {
                ventaId: ventaId,
                paisId
            }
            commit('INICIALIZAR_CREDITO_DEBITO', params);

            /* Recuperamos los tipos de comprobante */
            apiAxios.get(`ventas/${ventaId}/comprobantes-tipos`)
                .then(res => {
                    commit('SET_COMPROBANTES_TIPOS', res.data);

                    /* Recuperamos los datos del comprobante original */
                    return apiAxios.get(`ventas/${ventaId}/credito-debito`);
                })
                .then(res => {
                    commit('SET_VENTA_CREDITO_DEBITO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    /* Inicializa NCR Fee o Financiacion sobre un comprobante */
    inicializarCredito ( { commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }
            params.paisId = paisId;

            commit('INICIALIZAR_CREDITO_DEBITO', params);

            let getDatosCredito = false;

            if (params) {
                if (params.ventaId) {
                    if (params.ventaId != 0) {
                        getDatosCredito = true;
                    }
                }
            }

            if (getDatosCredito) {
                let url = '';
                if ((/true/i).test(params.creditoFinanciacion)) {
                    url = `ventas/${params.ventaId}/credito-financiacion`;
                } else {
                    url = `ventas/${params.ventaId}/credito-fee`;
                }

                apiAxios.get(url)
                    .then(res => {
                        commit('SET_CREDITO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    /* Recupera los comprobantes disponibles para generar la NCR por financiacion */
    getComprobantesCreditoFinanciacion ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CREDITO_FINANCIACION_COMPROBANTES');

            let queryString = '?clienteId=' + state.creditoFinanciacionCliente.id;

            apiAxios.get('ventas/credito-financiacion-comprobantes' + queryString)
                .then(res => {
                    commit('SET_CREDITO_FINANCIACION_COMPROBANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    /* Inicializa los datos de NCR Financiacion sobre 1 o más comprobantes */
    inicializarCreditoFinanciacion ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            /* Recuperamos la info de la NCR a partir de los comprobantes seleccionados */
            let comprobantesCredito = '';
            if (state.creditoFinanciacionComprobantes) {
                state.creditoFinanciacionComprobantes.forEach(comprobante => {
                    if ((/true/i).test(comprobante.selected)) {
                        if (comprobantesCredito.trim() == '') {
                            comprobantesCredito = comprobante.id.toString();
                        } else {
                            comprobantesCredito = new String().concat(comprobantesCredito, `,${comprobante.id.toString()}`);
                        }
                    }
                });
            }

            apiAxios.get('ventas/credito-financiacion?comprobantes=' + comprobantesCredito)
                .then(res => {
                    commit('SET_CREDITO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            if (parseFloat(state.total) == 0) {
                save = false;
                errorMessage = "El importe total del comprobante no puede ser igual a cero."
            }

            if (parseFloat(state.montoGravado)
                    + parseFloat(state.montoExento)
                    + parseFloat(state.montoNoGravado)
                    + parseFloat(state.montoIvaInscripto) == 0) {
                save = false;
                errorMessage = "El importe discriminado del comprobante no puede ser igual a cero."
            }

            if (!validarRenglonesDescripcion(state.renglonesDescripcion)) {
                save = false;
                errorMessage = 'Verifique la información correspondiente a la impresión del comprobante.\n'
                    + 'Al menos un renglón debe contener una descripción, y el importe de cada renglón debe ser un valor numérico'
                    + ' (en caso de no requerir impresión asignarle el valor cero).';
            }

            /* Si es una NCR o NDB, debe seleccionar el periodo correspondiente */
            let periodoAsociadoDesde = '1900-01-01';
            let periodoAsociadoHasta = '1900-01-01';

            if (state.comprobanteTipoId == 2 || state.comprobanteTipoId == 3
                    || state.comprobanteTipoId == 7 || state.comprobanteTipoId == 8) {
                if (state.ventaId == 0 & state.ventaReferencias.length == 0) {
                    if (moment(state.periodoAsociadoDesde).format('YYYY-MM-DD') == '1900-01-01'
                            || moment(state.periodoAsociadoHasta).format('YYYY-MM-DD') == '1900-01-01') {

                        save = false;
                        errorMessage = 'El tipo de comprobante seleccionado requiere que se defina el período asociado.\n'
                            + 'Complete por favor el período correspondiente.';
                    } else {
                        periodoAsociadoDesde = moment(state.periodoAsociadoDesde).format('YYYY-MM-DD');
                        periodoAsociadoHasta = moment(state.periodoAsociadoHasta).format('YYYY-MM-DD');
                    }
                }
            }

            if (save) {
                let venta= {
                    pjeAlicuotaIva: parseFloat(state.pjeAlicuotaIva),
                    fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                    fechaVencimiento: moment(state.fechaVencimiento).format('YYYY-MM-DD'),
                    clienteId: parseInt(state.clienteId),
                    formaPagoId: parseInt(state.formaPagoId),
                    comprobanteTipoId: parseInt(state.comprobanteTipoId),
                    formulario: state.formulario.trim().toUpperCase(),
                    numeroPuntoVenta: parseInt(state.numeroPuntoVenta),
                    numero: parseInt(state.numero),
                    monedaId: parseInt(state.monedaId),
                    cotizacion: parseFloat(state.cotizacion),
                    total: parseFloat(state.total),
                    montoGravado: parseFloat(state.montoGravado),
                    montoExento: parseFloat(state.montoExento),
                    montoNoGravado: parseFloat(state.montoNoGravado),
                    montoIvaInscripto: parseFloat(state.montoIvaInscripto),
                    monedaPagoId: parseInt(state.monedaPagoId),
                    // montoGravadoLocal: parseFloat(state.montoGravadoLocal),
                    // montoExentoLocal: parseFloat(state.montoExentoLocal),
                    // montoNoGravadoLocal: parseFloat(state.montoNoGravadoLocal),
                    // montoIvaInscriptoLocal: parseFloat(state.montoIvaInscriptoLocal),
                    sistemaCirculacionAbierta: (/true/i).test(state.sistemaCirculacionAbierta),
                    periodoAsociadoDesde,
                    periodoAsociadoHasta,
                    observaciones: state.observaciones.trim(),

                    presupuestoInternoId: parseInt(state.presupuestoInternoId),
                    ordenTrabajoId: parseInt(state.ordenTrabajoId),
                    
                    pjeCreditoDebito: parseFloat(state.pjeCreditoDebito)
                };

                if (state.certificadosServicio) {
                    let renglones = [];
                    for(let key in state.renglones) {
                        const certificadoServicio = state.renglones[key];
                        if (certificadoServicio.seleccionado) {
                            const renglon = {
                                certificadoServicioId: certificadoServicio.id,
                                certificadoServicio: {
                                    id: certificadoServicio.id,
                                    nombre: ''
                                },
                                importe: certificadoServicio.importe
                            }
                            renglones.push(renglon);
                        }
                    }
                    venta.renglones = renglones;
                }

                venta.renglonesDescripcion = state.renglonesDescripcion;

                let url = 'ventas';
                if (state.id != 0) {
                    url += '/' + state.id;
                    venta.rowVersion = state.rowVersion;
                }

                if (state.ventaId != 0) {
                    venta.comprobantesReferencias = [{
                        comprobanteAsociadoId: state.ventaId,
                        comprobanteAsociadoCausaId: 1
                    }];
                }
                if (state.ventaReferencias.length != 0) {
                    /* 2: Credito x Financiacion / 3: Credito x Fee */
                    venta.comprobantesReferencias = state.ventaReferencias.map(venta => ({
                        comprobanteAsociadoId: venta.id,
                        comprobanteAsociadoCausaId: (/true/i).test(state.creditoFinanciacion) ? 2 : 3
                    }));
                }

                apiAxios.post(url, venta)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    certificadoSeleccionado ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CERTIFICADO_SELECCIONADO');
            resolve();
        })
    },
    actualizarSeleccionCertificados ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('ACTUALIZAR_SELECCION_CERTIFICADOS');
            resolve();
        })
    },
    calcularMontosTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_MONTOS_TOTAL');
            resolve();
        })
    },
    calcularMontoIva ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_MONTO_IVA');
            resolve();
        })
    },
    calcularTotalesCreditoDebito ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_TOTALES_CREDITO_DEBITO');
            resolve();
        })
    },
    setImporteRenglon ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('SET_IMPORTE_RENGLON');
            resolve();
        })
    },
    actualizarTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('ACTUALIZAR_TOTAL');
            resolve();
        })
    },
    calcularTotales ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_TOTALES');
            resolve();
        })
    },
    addRenglonDescripcion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('ADD_RENGLON_DESCRIPCION');
            resolve();
        })
    },
    validarRenglonDescripcion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('VALIDAR_RENGLON_DESCRIPCION');
            resolve();
        })
    },
    setFormaPago: ( { commit }, formaPago) => {
        commit('SET_FORMA_PAGO', formaPago);
    },
    setMoneda: ( { commit }, moneda) => {
        commit('SET_MONEDA', moneda);
    },
    setMonedaPago: ( { commit }, moneda) => {
        commit('SET_MONEDA_PAGO', moneda);
    },
    setComprobanteTipo: ( { commit }, comprobanteTipo) => {
        commit('SET_COMPROBANTE_TIPO', comprobanteTipo);
    },
    calcularFechaVencimiento: ( { commit }) => {
        commit('CALCULAR_FECHA_VENCIMIENTO');
    },
    calcularTotalesCreditoFinanciacion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_TOTALES_CREDITO_FINANCIACION');
            resolve();
        })
    },
    setPresupuesto: ({ commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('SET_PRESUPUESTO', params);
            resolve();
        })
    },

    getDatos ( { rootState, commit }, ventaId ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }

            // console.log(rootState.user);

            commit('INICIALIZAR_DATOS');

            if (ventaId) {
                apiAxios.get('ventas/' + ventaId )
                    .then(res => {
                        let identificacion = `${res.data.documentoTipo} ${res.data.documentoNumero}`;

                        let total = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.total)}`;
                        let montoGravado = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoGravado)}`;
                        let montoExento = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoExento)}`;
                        let montoNoGravado = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoNoGravado)}`;
                        let montoIvaInscripto = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.montoIvaInscripto)}`;

                        let ventaDatos = [
                          { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                          { 'nombre': 'fechaComprobante', 'campo': 'Fecha de Comp.', 'valor': res.data.fechaComprobante, 'formato': 'fecha' },
                          { 'nombre': 'fechaVencimiento', 'campo': 'Fecha de Venc.', 'valor': res.data.fechaVencimiento, 'formato': 'fecha' },
                          { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                          { 'nombre': 'condicionFiscal', 'campo': 'Cond. Fiscal', 'valor': res.data.condicionFiscal, 'formato': '' },
                          // { 'nombre': 'documentoTipo', 'campo': 'Tipo Identificación', 'valor': res.data.documentoTipo, 'formato': '' },
                          // { 'nombre': 'documentoNumero', 'campo': 'Cod. Identificación', 'valor': res.data.documentoNumero, 'formato': '' },
                          { 'nombre': 'identificacion', 'campo': 'Tipo y Cod. Identificación', 'valor': identificacion, 'formato': '' },
                        ]

                        if (paisId == 5) {
                          ventaDatos.push({ 'nombre': 'giroEmpresa', 'campo': 'Giro Empresa', 'valor': res.data.giroEmpresa, 'formato': '' });
                        }

                        ventaDatos.push(
                          { 'nombre': 'comprobante', 'campo': 'Comprobante', 'valor': res.data.comprobante, 'formato': '' },
                          { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' }
                        );

                        if (res.data.monedaId != 101) {
                          ventaDatos.push({ 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': res.data.cotizacion, 'formato': 'moneda' });
                        }

                        ventaDatos.push(
                          { 'nombre': 'montoGravado', 'campo': 'Monto Gravado', 'valor': montoGravado, 'formato': '' },
                          { 'nombre': 'montoExento', 'campo': 'Monto Exento', 'valor': montoExento, 'formato': '' },
                          { 'nombre': 'montoNoGravado', 'campo': 'Monto No Gravado', 'valor': montoNoGravado, 'formato': '' },
                          { 'nombre': 'montoIvaInscripto', 'campo': 'Monto Iva Insc.', 'valor': montoIvaInscripto, 'formato': '' },
                          // { 'nombre': 'montoTotal', 'campo': 'Monto Total', 'valor': res.data.montoTotal, 'formato': 'moneda' },
                        )

                        if (res.data.monedaId != res.data.monedaPagoId) {
                          ventaDatos.push({ 'nombre': 'monedaPagoDescripcion', 'campo': 'Moneda Pago', 'valor': res.data.monedaPagoDescripcion, 'formato': '' });
                        }

                        ventaDatos.push({ 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' });


                        if ((/true/i).test(res.data.anulaFacturaCreditoElectronica)) {
                          ventaDatos.push({ 'nombre': 'anulaFacturaCreditoElectronica', 'campo': '', 'valor': 'Anula Comprobante de Crédito Electrónico', 'formato': '' });
                        }

                        if (moment(res.data.periodoAsociadoDesde).format('YYYY-MM-DD') != '1900-01-01') {
                          ventaDatos.push({ 'nombre': 'periodoAsociadoDesde', 'campo': 'Período - Desde', 'valor': res.data.periodoAsociadoDesde, 'formato': 'fecha' });
                          ventaDatos.push({ 'nombre': 'periodoAsociadoHasta', 'campo': 'Período - Hasta', 'valor': res.data.periodoAsociadoHasta, 'formato': 'fecha' });
                        }

                        if (res.data.presupuestoInternoId != 0) {
                          ventaDatos.push({ 'nombre': 'presupuestoNumero', 'campo': 'Nro.Presupuesto', 'valor': res.data.presupuestoNumero, 'formato': '' });
                          ventaDatos.push({ 'nombre': 'presupuestoInterno', 'campo': 'Presupuesto Interno', 'valor': res.data.presupuestoInterno, 'formato': '' });
                          ventaDatos.push({ 'nombre': 'ordenTrabajo', 'campo': 'Orden de Trabajo', 'valor': res.data.ordenTrabajo, 'formato': '' });
                        }

                      if ((/true/i).test(res.data.negociada)) {
                        ventaDatos.push({ 'nombre': 'negociada', 'campo': 'Venta Negociada', 'valor': 'Si', 'formato': '' });
                      }

                      if ((/true/i).test(res.data.comprobanteIva)) {
                        ventaDatos.push({ 'nombre': 'comprobanteIva', 'campo': 'Comprobante de Tipo IVA', 'valor': 'Si', 'formato': '' });
                      }

                      let ventaNegociacionDatos = []
                      if (res.data.ventaNegociacion) {
                        ventaNegociacionDatos.push(
                          { 'nombre': 'proveedor', 'campo': 'Agente', 'valor': res.data.ventaNegociacion.proveedor, 'formato': '' },
                          { 'nombre': 'numeroBoleto', 'campo': 'Nro.Boleto', 'valor': res.data.ventaNegociacion.numeroBoleto, 'formato': '' },
                          { 'nombre': 'fechaAcreditacion', 'campo': 'Fecha Acredit.', 'valor': res.data.ventaNegociacion.fechaAcreditacion, 'formato': 'fecha' },
                          { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.ventaNegociacion.bancoCuenta, 'formato': '' },
                          { 'nombre': 'montoAcreditado', 'campo': 'Monto Acredit.', 'valor': res.data.ventaNegociacion.montoAcreditado, 'formato': 'moneda' },
                          { 'nombre': 'montoIntereses', 'campo': 'Monto Intereses', 'valor': res.data.ventaNegociacion.montoIntereses, 'formato': 'moneda' },
                          { 'nombre': 'montoGastos', 'campo': 'Monto Gastos', 'valor': res.data.ventaNegociacion.montoGastos, 'formato': 'moneda' },
                          { 'nombre': 'montoImpuestos', 'campo': 'Monto Impuestos', 'valor': res.data.ventaNegociacion.montoImpuestos, 'formato': 'moneda' },
                          { 'nombre': 'montoRetenciones', 'campo': 'Monto Retenciones', 'valor': res.data.ventaNegociacion.montoRetenciones, 'formato': 'moneda' },
                          { 'nombre': 'montoTotal', 'campo': 'Monto Total', 'valor': res.data.ventaNegociacion.montoTotal, 'formato': 'moneda' },
                          { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.ventaNegociacion.observaciones, 'formato': '' },
                        )
                      }

                      var params = {
                        ventaDatos,
                        ventaRenglonesDatos: res.data.renglones,
                        ventaRenglonesDescripcionDatos: res.data.renglonesDescripcion,
                        ventaAsociadasDatos: res.data.comprobantesAsociados,
                        ventaReferenciasDatos: res.data.comprobantesReferencias,
                        moneda: res.data.moneda.trim(),
                        ventaNegociacionDatos
                      }

                      commit('SET_VENTA_DATOS', params);
                      resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
    getDatosRpt ( { commit }, ventaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (ventaId) {
                apiAxios.get('ventas/' + ventaId )
                    .then(res => {
                        let params = {
                            ventaDatos: res.data,
                            ventaRenglonesDatos: res.data.renglones,
                            ventaRenglonesDescripcionDatos: res.data.renglonesDescripcion
                        }

                        commit('SET_VENTA_DATOS_RPT', params);
                        resolve();
                    })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
